import { Lock } from "lucide-react";
import React from "react";
import { Navigate } from "react-router-dom";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components";
import { usePermissions } from "@/context/permissions";
import { useFirstAllowedRoute } from "@/routes/route-helpers";

export const NoPermissionsPage: React.FC = () => {
  const { isLoading } = usePermissions();
  const firstAllowedRoute = useFirstAllowedRoute();

  if (isLoading) {
    return null;
  }

  if (firstAllowedRoute) {
    return <Navigate to={firstAllowedRoute} replace />;
  }

  return (
    <div className="h-full w-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-background">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 dark:bg-yellow-900/20 mb-4">
            <Lock className="h-6 w-6 text-yellow-600 dark:text-yellow-500" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            Sem permissões
          </CardTitle>
          <CardDescription className="text-gray-600 dark:text-gray-400">
            Infelizmente não há nada para ver por aqui
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-500 dark:text-gray-200">
            Você não possui permissões para acessar nenhuma funcionalidade do sistema.
            Entre em contato com o administrador para solicitar as permissões necessárias.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

